import React from "react";
import { Spinner } from "reactstrap";

const LoadingSpinner = () => {
  return (
    <div>
      <Spinner />
      <p>Loading...</p>
    </div>
  );
};

export default LoadingSpinner;
